import React from "react";
import './Country.css'
import { Link } from "react-router-dom";
const Country = () => {
  return( 
  <div>
<div className="country" data-aos="fade-up" data-aos-duration="800">
    <div className="title">지역별 코스 추천</div>
    <div className="subtitle">완벽한 하루에서 추천하는 코스예요.</div>
    <div className="selectbox">
      <ul>
        <li><a href="#" class="active">BEST!</a></li>
        <li><a href="#">서울</a></li>
        <li><a href="#">경기</a></li>
        <li><a href="#">전국</a></li>
      </ul>
    </div>
    <div className="grid">
      <a href="#">
      <div className="box1" data-aos="fade-up" data-aos-duration="800">
        <img src="images/gal1.jpg" alt="강릉이미지" />
        <div className="blackbox_3">
          <div className="con_text">
        <div className="con_word">강릉편</div>
        <div className="con_subword">강릉에서 바다보며<br />
          걷는 데이트코스</div>
          <div className="con_subword_2">4시 10분 | 3,000원</div>
        </div>
        </div>
      </div>
    </a>
    
    <a href="#">
      <div className="box2" data-aos="fade-up" data-aos-duration="800">
      <img src="images/gal2.jpg" alt="강동구이미지" />
        <div className="blackbox_3">
          <div className="con_text">
        <div className="con_word">강동구편</div>
        <div className="con_subword">강동구에서 분위기 맛집<br />
          데이트를 즐겨보자!</div>
          <div className="con_subword_2">4시 30분 | 25,000원</div>
        </div>
        </div>
      </div>
    </a>
     
      <a href="#">
      <div className="box3" data-aos="fade-up" data-aos-duration="800">
      <img src="images/gal3.png" alt="양재이미지" />
        <div className="blackbox_3">
          <div className="con_text">
        <div className="con_word">양재편</div>
        <div className="con_subword">양재에서 문화생활
<br />
즐기는 데이트!</div>
          <div className="con_subword_2">3시 30분 | 47,000원</div>
        </div>
        </div>
      </div>
    </a>
     
      <a href="#">
      <div className="box4" data-aos="fade-up" data-aos-duration="800">
      <img src="images/gal4.png" alt="안양이미지" />
        <div className="blackbox_3">
          <div className="con_text">
        <div className="con_word">안양편</div>
        <div className="con_subword">걸으면서 느끼는
<br />
안양의 데이트 코스!</div>
          <div className="con_subword_2">3시간 | 46,400원</div>
        </div>
        </div>
      </div>
    </a>
    </div>
    <div className="view" data-aos="fade-up" data-aos-duration="800"><Link to="/Sub2">더보기</Link></div>
  </div>
  </div>
  );
};


export default Country;
